import { SEO, Text } from '@components'
import CommonPageLayout from '@layouts/CommonPageLayout'

import styles from './style.module.css'

import privacyPolicy from '@constants/privacyPolicy'

function PrivacyPolicyModule() {
  return (
    <>
      <SEO
        title='Privacy policy'
        description='Kami menghargai dan melindungi privasi serta data pribadi Anda. Baca selengkapnya mengenai kebijakan pengguna di sini.'
      />

      <div className={styles.content}>
        <Text tag="h1" variant="title" className={styles.title}>
          {privacyPolicy.title}
        </Text>

        <Text tag="h2" variant="lightTitle">
          {privacyPolicy.h3}
        </Text>

        <Text fontWeight={700} className={styles.policyDate}>
          {privacyPolicy.h4}
        </Text>

        <Text
          variant="smallDescription"
          className={styles.paragraph}
          fontWeight={300}
        >
          {privacyPolicy.openParagraph}
        </Text>

        {privacyPolicy.list.map((content, index) => (
          <div
            key={`privacy_policy_${index}`}
            className={styles.pointContainer}
          >
            <Text tag="h4">{content.title}</Text>

            <Text
              variant="smallDescription"
              className={styles.paragraph}
              fontWeight={300}
            >
              {content.description}
            </Text>

            {content.points && (
              <ul className={styles.point}>
                {content.points.map((point, idx) => (
                  <li
                    key={`point_${index}_${idx}`}
                    className={styles.pointList}
                  >
                    <Text
                      variant="smallDescription"
                      className={styles.paragraph}
                      fontWeight={300}
                    >
                      {point}
                    </Text>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </>
  )
}

PrivacyPolicyModule.getLayout = page => {
  return (
    <CommonPageLayout containerClassName={styles.container}>
      {page}
    </CommonPageLayout>
  )
}

export default PrivacyPolicyModule
